import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditionsComponent } from '../../../pages/terms-conditions/terms-conditions.component';


@Component({
  standalone: false,
  selector: 'app-terms-form',
  templateUrl: './terms-form.component.html',
  styleUrls: ['./terms-form.component.scss']
})
export class TermsFormComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  openTermsConditionsDialog(){
    const dialogRef = this.dialog.open(TermsConditionsComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
    });

    
  }

  
  ngOnInit() {
  }

}
